import { render, staticRenderFns } from "./promoAnnouncer.vue?vue&type=template&id=e884c740&scoped=true"
import script from "./promoAnnouncer.vue?vue&type=script&lang=js"
export * from "./promoAnnouncer.vue?vue&type=script&lang=js"
import style0 from "./promoAnnouncer.vue?vue&type=style&index=0&id=e884c740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e884c740",
  null
  
)

export default component.exports